import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAbility } from '@casl/react';
import { selectNotificationById } from '../../../managers/NotificationListManager/selectors';
import {
  ABOVE_90,
  DUPLICATE_EMAIL,
  ONLY_MALE,
  TEAM_SIZE_REACHED,
  UNDER_12,
  WITHOUT_COUPON,
} from '../../../utils/notification.util';
import OnlyMaleNotification from './OnlyMaleNotification';
import DuplicateEmailNotification from './DuplicateEmailNotification';
import AgeAbove90 from './AgeAbove90';
import AgeUnder12 from './AgeUnder12';
import WithoutCoupon from './WithoutCoupon';
import { ignoreNotificationAction } from '../../../managers/NotificationListManager/actions';
import { AbilityContext } from '../../../casl/AbilityContext';
import TeamSizeReachedNotification from './TeamSizeReachedNotification';

function NotificationItem({ id, view }) {
  const dispatch = useDispatch();
  const notification = useSelector(state => selectNotificationById(state, id));
  const ability = useAbility(AbilityContext);
  const canIgnore = ability.can('update', 'Notification');
  const handleIgnore = useCallback(() => {
    dispatch(ignoreNotificationAction(1, notification.id));
  }, [dispatch, notification.id]);
  //   based on notification type
  switch (notification.rule.name) {
    case ONLY_MALE:
      return (
        <OnlyMaleNotification
          team={notification.team}
          createdAt={notification.createdAt}
          updatedAt={notification.updatedAt}
          onIgnore={handleIgnore}
          status={notification.status}
          disableIgnore={notification.isIgnoring}
          canIgnore={canIgnore}
        ></OnlyMaleNotification>
      );
    case ABOVE_90:
      return (
        <AgeAbove90
          member={notification.member}
          createdAt={notification.createdAt}
          updatedAt={notification.updatedAt}
          onIgnore={handleIgnore}
          status={notification.status}
          disableIgnore={notification.isIgnoring}
          canIgnore={canIgnore}
        ></AgeAbove90>
      );
    case UNDER_12:
      return (
        <AgeUnder12
          member={notification.member}
          createdAt={notification.createdAt}
          updatedAt={notification.updatedAt}
          onIgnore={handleIgnore}
          status={notification.status}
          disableIgnore={notification.isIgnoring}
          canIgnore={canIgnore}
        ></AgeUnder12>
      );
    case WITHOUT_COUPON:
      return (
        <WithoutCoupon
          member={notification.member}
          createdAt={notification.createdAt}
          updatedAt={notification.updatedAt}
          onIgnore={handleIgnore}
          status={notification.status}
          disableIgnore={notification.isIgnoring}
          canIgnore={canIgnore}
        ></WithoutCoupon>
      );
    case DUPLICATE_EMAIL:
      return (
        <DuplicateEmailNotification
          notification={notification}
          createdAt={notification.createdAt}
          updatedAt={notification.updatedAt}
          onIgnore={handleIgnore}
          status={notification.status}
          disableIgnore={notification.isIgnoring}
          canIgnore={canIgnore}
          view={view}
        />
      );
    case TEAM_SIZE_REACHED:
      return (
        <TeamSizeReachedNotification
          event={notification.event}
          createdAt={notification.createdAt}
          updatedAt={notification.updatedAt}
          onIgnore={handleIgnore}
          status={notification.status}
          disableIgnore={notification.isIgnoring}
          canIgnore={canIgnore}
        />
      );
    default:
      return null;
  }
}

export default memo(NotificationItem);
